export default {"src":"/_next/static/media/mandate.7c4eea79.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};